<h2 mat-dialog-title>Assign Rider</h2>

<mat-dialog-content [formGroup]="assignRiderForm" class="space-y-4">
  <!-- Driver Name -->
  <div>
    <label>Driver Name</label>
    <mat-form-field appearance="outline" class="w-full">
      <input
        matInput
        formControlName="driverName"
        placeholder="Enter driver name"
      />
      <mat-error
        *ngIf="assignRiderForm.get('driverName')?.hasError('required')"
      >
        Driver name is required
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Vehicle Plate Number -->
  <div>
    <label>Vehicle Plate Number</label>
    <mat-form-field appearance="outline" class="w-full">
      <input
        matInput
        formControlName="vehiclePlate"
        placeholder="Enter vehicle plate number"
      />
      <mat-error
        *ngIf="assignRiderForm.get('vehiclePlate')?.hasError('required')"
      >
        Vehicle plate number is required
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Primary Number -->
  <div>
    <label>Primary Number</label>
    <div class="flex gap-2">
      <mat-form-field appearance="outline" class="w-1/3">
        <mat-select formControlName="primaryCode">
          <mat-option value="+233">🇬🇭 (+233)</mat-option>
          <mat-option value="+234">🇳🇬 (+234)</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="flex-1">
        <input
          matInput
          formControlName="primaryNumber"
          placeholder="Enter primary phone number"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          (input)="limitNumberLength('primaryCode', 'primaryNumber', $event)"
        />
        <mat-error
          *ngIf="assignRiderForm.get('primaryNumber')?.hasError('required')"
        >
          Primary number is required
        </mat-error>
        <mat-error
          *ngIf="
            assignRiderForm.get('primaryNumber')?.hasError('invalidNumber')
          "
        >
          Invalid number for selected country
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <!-- Secondary Number -->
  <div>
    <label>Secondary Number</label>
    <div class="flex gap-2">
      <mat-form-field appearance="outline" class="w-1/3">
        <mat-select formControlName="secondaryCode">
          <mat-option value="+233">🇬🇭 (+233)</mat-option>
          <mat-option value="+234">🇳🇬 (+234)</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="flex-1">
        <input
          matInput
          formControlName="secondaryNumber"
          placeholder="Enter secondary phone number"
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          (input)="limitNumberLength('secondaryCode', 'secondaryNumber', $event)"
        />
        <mat-error
          *ngIf="
            assignRiderForm.get('secondaryNumber')?.hasError('invalidNumber')
          "
        >
          Invalid number for selected country
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    mat-flat-button
    color="primary"
    (click)="onSubmit()"
    [disabled]="assignRiderForm.invalid"
  >
    Assign
  </button>
</mat-dialog-actions>
